// extracted by mini-css-extract-plugin
export default {"sort":"SortArrow_sort__n-UZO","asc":"SortArrow_asc__fZmKR","desc":"SortArrow_desc__sjmwN"};